export default "__VITE_ASSET__90925417__"